import { useTranslation } from '../../lib/i18n'

export default function BadgingRequestedNotification({ notification }) {
  const { t } = useTranslation()
  return (
    <>
      <p className="w-full max-w-200 md:max-w-300 line-clamp-2 overflow-hidden">
        <span className="text-off-black font-bold">
          {notification.notifiable?.badge?.name}
        </span>{' '}
        {t('common.hasBeenOfferedToYou')}
      </p>
    </>
  )
}
